const moduleRouteMapping = {
  // Route file: Required module key from licensing
  authRoute: "null", // No licensing check needed for auth
  defaultRoute: "null", // No licensing check needed for defaults (dashboard, etc)
  productRoute: "productConfig",
  customerRoute: "customers",
  accountRoute: "accountsContracts",
  glAccountingRoute: "glAndAccounting",
  systemAdminRoute: "sysAdmin",
  groupRoute: "customers", // Group is part of customer module
  securityRoute: "securityManagement",
  operationsRoute: "operations",
  configurations: "sysAdmin", // Configurations are part of sysAdmin
  treasuryRoute: "treasuryInvestments",
  contractBookingRoute: "treasuryInvestments",
  reportsRoute: "reportsAnalytics",
  tellerRoute: "tellerOperations",
  serviceProviderRoute: "agencyBanking",
  FAQ: null, // FAQ doesn't need licensing check
  walletRoute: ["walletProduct", "walletAccount"],
};

export default moduleRouteMapping;
